import * as React from 'react';
import * as webp from '@alife/bc-webp';
import { triggerEvent } from '../utils';
import safeLog from '@alife/bc-safe-log';
interface CustomizeOtherProps {
  onItemClick?: (event: React.MouseEvent<HTMLElement>) => void;
  thumb?: boolean;
  thumbWidth: number;
  thumbHeight: number;
}
export default function Customize(
  props: (PcMainImage.LightCustomData | PcMainImage.CustomData) &
    CustomizeOtherProps,
) {
  if (props.thumb)
    return (
      <div className="vr-thumb" onClick={props.onItemClick}>
        <div className="vr-place-holder">
          <div
            className="thumb-shadow"
            style={{ width: props.thumbWidth, height: props.thumbHeight }}
          ></div>
          <img
            src="https://img.alicdn.com/tfs/TB1MEK_2uL2gK0jSZFmXXc7iXXa-20-20.svg"
            alt="vr-icon"
            className="vr-icon"
          />
        </div>
        <img src={webp.use(props.cover)} alt="image" />
      </div>
    );
  return (
    <div
      className="vr-big-image"
      onClick={() => {
        const el = document.querySelector('.customise-entry') as HTMLElement;
        el && el.click();
        safeLog(
          '/sc.details.commonLogs',
          'CLK',
          `info=${props.type}&position=image&action=openMainImageDialog`,
        );
      }}
    >
      <img
        src="https://img.alicdn.com/tfs/TB1MOaZ2AL0gK0jSZFAXXcA9pXa-78-78.svg"
        alt="vr-icon"
        className="vr-icon-big"
      />
      <img src={webp.use(props.cover)} alt="image" />
    </div>
  );
}
